import { gql } from 'apollo-angular'

/**
 * Re-evaluate saved tests against the scanner's current baseline (app server
 * remote schema: server/src/api/baseline.resolver.ts). Admins, physicists and
 * AQS support only; one outcome per test.
 */
export default gql`
  mutation reevaluatePhantomTests($phantomTestIds: [Int!]!) {
    reevaluatePhantomTests(data: { phantomTestIds: $phantomTestIds }) {
      id
      previousResult
      result
      error
    }
  }
`
